// extracted by mini-css-extract-plugin
export default {"debtDrawer":"debtDrawer","form":"form"};